import React from "react";
import { useContent } from "../../lib/content";

export const InstallStrip = () => {
  const PHOTOS = useContent().photos.strip;
  return (
  <section data-testid="install-strip" className="section-pad bg-white">
    <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
      <span className="eyebrow">Our work</span>
      <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-[#0a1f44]">Real installs, real homes.</h2>
      <div className="mt-10 grid sm:grid-cols-3 gap-5">
        {PHOTOS.map((p, i) => (
          <figure key={i} data-testid={`install-photo-${i + 1}`} className="group overflow-hidden rounded-2xl bg-slate-100">
            <img src={p.src} alt={p.alt} loading="lazy" className="w-full aspect-square object-cover transition-transform duration-500 group-hover:scale-105" />
          </figure>
        ))}
      </div>
    </div>
  </section>
  );
};
